import React from 'react';
import SEOHead from '../components/SEOHead';
import ContactForm from '../components/ContactForm';
import { COMPANY_INFO } from '../data/scrapeData';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Kontakt – Vognmand & Entreprenør DBM aps"
        description="Kontakt Vognmand & Entreprenør DBM aps direkte eller via kontaktformular: Nick Mann Hedegaard Laursen, Linda Mann Hedegaard Laursen."
      />

      {/* Header Banner */}
      <section
        className="relative bg-cover bg-center bg-no-repeat text-white py-20 sm:py-32 px-4 sm:px-8 border-b-4 border-neutral-800 text-center flex items-center justify-center min-h-[350px] sm:min-h-[440px]"
        style={{
          backgroundImage:
            'url("https://assets.auxodev.dk/assets/97798019-8392-40d4-89ba-059b36d499c2/skaermbillede-2024-04-02-kl-13-44-24.png")',
        }}
      >
        <div className="relative z-10 max-w-4xl mx-auto drop-shadow-lg [text-shadow:_0_2px_10px_rgba(0,0,0,0.8)]">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-black tracking-tight text-white">
            Kontakt
          </h1>
          <div className="mt-6">
            <a
              href="#kontakt-sektion"
              className="inline-block bg-black hover:bg-neutral-800 text-white font-bold px-8 py-3.5 rounded text-sm uppercase tracking-wider border border-white/30 transition-colors shadow-lg"
            >
              Kontakt os her
            </a>
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section id="kontakt-sektion" className="py-12 px-4 sm:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          
          {/* Direct Contact Info */}
          <div className="space-y-8">
            <div className="bg-white p-6 sm:p-8 rounded shadow-md border border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Kontakt
              </h2>
              <p className="text-gray-700 text-sm font-medium mb-6">
                Du er velkommen til at kontakt os direkte eller via kontaktformular:
              </p>

              {/* Nick info */}
              <div className="mb-6 p-4 bg-gray-50 rounded">
                <h3 className="text-base font-bold text-gray-900">
                  Nick Mann Hedegaard Laursen
                </h3>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                  Direktør/Ejer
                </p>
                <div className="space-y-1 text-sm text-gray-800">
                  <p className="whitespace-nowrap">
                    <span className="font-semibold text-gray-600">Tlf:</span>{' '}
                    <a href="tel:+4521416808" className="hover:text-black font-bold whitespace-nowrap">
                      21416808
                    </a>
                  </p>
                  <p className="whitespace-nowrap">
                    <span className="font-semibold text-gray-600">Mail:</span>{' '}
                    <a href="mailto:dbmapsnick@gmail.com" className="hover:text-black font-bold underline whitespace-nowrap">
                      dbmapsnick@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              {/* Linda info */}
              <div className="p-4 bg-gray-50 rounded">
                <h3 className="text-base font-bold text-gray-900">
                  Linda Mann Hedegaard Laursen
                </h3>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                  Kontoransvarlig
                </p>
                <div className="space-y-1 text-sm text-gray-800">
                  <p className="whitespace-nowrap">
                    <span className="font-semibold text-gray-600">Tlf:</span>{' '}
                    <a href="tel:+4524606077" className="hover:text-black font-bold whitespace-nowrap">
                      24606077
                    </a>
                  </p>
                  <p className="whitespace-nowrap">
                    <span className="font-semibold text-gray-600">Mail:</span>{' '}
                    <a href="mailto:lindadbmaps@gmail.com" className="hover:text-black font-bold underline whitespace-nowrap">
                      lindadbmaps@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div>
            <ContactForm />
          </div>

        </div>
      </section>

      {/* Map Section */}
      <section className="w-full h-80 sm:h-96 bg-gray-200 border-t border-gray-300 overflow-hidden">
        <iframe
          title="Vognmand & Entreprenør DBM aps placering"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d282536.7038819754!2d9.32969029958918!3d56.43876640852419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464bf8f516b4ba37%3A0xfc8a2c79a484a9b6!2sVognmand%20%26%20Entrepren%C3%B8r%20Dbm%20Aps!5e0!3m2!1sen!2sdk!4v1786101173697!5m2!1sen!2sdk"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          className="grayscale contrast-125 opacity-85 hover:grayscale-0 hover:opacity-100 hover:contrast-100 transition-all duration-500"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
      </section>
    </div>
  );
}
